import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Reset from './views/Reset.vue';
import Auth from './views/Auth.vue';
import Upgrade from './views/Upgrade.vue';
import Limit from './views/Limit.vue';
import Illegal from './views/Illegal.vue';

export default [
  {
    path: 'login',
    component: Login,
    name: '用户登录',
  },
  {
    path: 'register',
    component: Register,
    name: '用户注册',
  },
  {
    path: 'reset',
    component: Reset,
    name: '找回密码',
  },
  {
    path: 'auth',
    component: Auth,
    name: '用户授权',
  },
  {
    path: 'upgrade',
    component: Upgrade,
    name: '升级会员',
  },
  {
    path: 'limit',
    component: Limit,
    name: '仅限认证公众号',
  },
  {
    path: 'illegal',
    component: Illegal,
    name: '无权限',
  },
];
